import React from 'react';
import { FrameWrap } from './FrameWrapper.styles';

export const FrameWrapper: React.FC<{}> = ({ children }) => {
  return <FrameWrap>{children}</FrameWrap>;
};
